import type { ReactNode } from "react";

export interface IFormLabelProps {
  htmlFor?: string;
  children: ReactNode;
  isInvalid?: boolean;
  disabled?: boolean;
  fontSize?: string;
  className?: string;
}

export function FormLabel({
  htmlFor,
  children,
  fontSize,
  isInvalid = false,
  disabled = false,
  className = "",
}: Readonly<IFormLabelProps>) {
  return (
    <label
      htmlFor={htmlFor}
      className={`mb-1 flex select-none items-center justify-start font-normal not-italic
      ${fontSize ? `text-[${fontSize}]` : "text-[13px]"}
      ${isInvalid && "text-action-danger"}
      ${disabled ? "text-content-disabled" : "text-content-primary dark:text-invertedPrimary80"}
      ${className}`}
    >
      {children}
    </label>
  );
}
